<template>
  <b-form-group :label="item.field.prompt">
    <input class="form-control"
           v-model.number="item.value"
           :disabled="item.disabled"
           :required="item.field.mandatory"
           :state="isValid"
           v-on:focus='focus'
           v-on:blur='blur'
           v-on:keypress='limitNumber($event)'>
    </input>
    <b-form-invalid-feedback :state="isValid">{{errorMessage}}</b-form-invalid-feedback>
  </b-form-group>
</template>


<script>

export default {
  name: 'DecimalField',
  props: {
    item: { type: Object }
  },
  data () {
    return { isValid: null, errorMessage: '' }
  },
  computed: {
    step () {
      return 1 / (10 ** this.item.field.decimal_places)
    }
  },
  methods: {
    countDecimalPlaces (value) {
      return value % 1 ? value.toString().split('.')[1].length : 0
    },
    focus (event) {
      setTimeout(() => {
        if (event.target.value === '0') {
          event.target.value = ''
        }
      }, 1)
    },
    blur (event) {
      setTimeout(() => {
        if (event.target.value === '') {
          event.target.value = '0'
        }
      }, 1)
    },
    limitNumber (event) {
      var charCode = (event.which) ? event.which : event.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault()
      } else if (this.countDecimalPlaces(event.target.value + event.key) > this.item.field.decimal_places) {
        event.preventDefault()
      } else {
        return true
      }
    },
    validate () {
      this.isValid = true
      this.errorMessage = ''
      if (this.item.field.mandatory && (this.item.value == null)) {
        this.isValid = false
        this.errorMessage = 'Please complete'
      }
      return this.isValid
    },
    value () {
      if (this.item.value != null && this.item.value !== '') {
        return { field_name: this.item.field.field_name, string_value: this.item.value.toFixed(this.item.field.decimal_places) }
      } else {
        return { field_name: this.item.field.field_name, string_value: '' }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data_entry/DecimalField.vue